// src/hooks/useProjects.js
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import axios from 'axios';
// import { setProjects, setError, clearProjects } from '../features/projectsSlice';
// import { setSingleProject, setError, clearProject } from '../features/singleProject';
import { setProjectHistory, setErrorHistory, clearProjectHistory } from '../features/ProjectHistory';

const API_URL = 'https://api-4h4srbodqa-uc.a.run.app/api';

export const useProjectHistory = (projectId) => {
  const dispatch = useDispatch();

  return useQuery({
    queryKey: ['ProjectHistoryOver', projectId],
    queryFn: async () => {
      const { data } = await axios.get(`${API_URL}/projects/history/${projectId}`);
      console.log('Raw API response for history:', data); // Log the raw API response
      return data;
    },
    onSuccess: (data) => {
      console.log('Setting project History in Redux:', data);
      dispatch(setProjectHistory(data));
    },
    onError: (error) => {
      console.error('Fetch error:', error);
      dispatch(setErrorHistory(error.message));
    },
    refetchInterval: 5000,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
};